import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';

/**
 * @class ExpensesItem
 *
 */
export class ExpensesItem extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'name', 'description' ];
    }
}

AccessorsMutatorsDecorator(
    'id',
    ...ExpensesItem.translatableAttributesWithLanguageAliases,
    'property_id',
    'property',
    'payment_vouchers_count',
    'ntmp_account',
    'status'
)(ExpensesItem);



// WEBPACK FOOTER //
// ./src/pms-api/models/expenses-item.model.js